import { cva, type VariantProps } from "class-variance-authority"
import * as React from "react"

import { cn } from "../lib/utils"

const noteVariants = cva(
  "inline-flex items-center justify-center rounded px-2 py-1 text-label-md font-semibold",
  {
    variants: {
      variant: {
        primary: "bg-bg-primary text-primary",
        secondary: "bg-bg-secondary text-secondary",
        attention: "bg-bg-attention text-attention",
        neutral: "bg-background text-gray",
      },
    },
    defaultVariants: {
      variant: "primary",
    },
  }
)

export interface NoteProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof noteVariants> {}

const Note = React.forwardRef<HTMLSpanElement, NoteProps>(
  ({ className, variant, ...props }, ref) => (
    <span ref={ref} className={cn(noteVariants({ variant, className }))} {...props} />
  )
)
Note.displayName = "Note"

export { Note, noteVariants }
